<template>
  <div class="submission-grid-item">
    <img
      class="submission-grid-item__thumbnail"
      :src="submission.thumbnail"
      alt=""
    />
    <div class="submission-grid-item__menu">
      <label class="toggle" :for="submission.id + '_critique'">
        <input
          :disabled="deadlinePassed"
          type="checkbox"
          :name="submission.id + '_critique'"
          :id="submission.id + '_critique'"
          :checked="submission.critique"
          @change="toggleCritiqueHandler"
        />
        <div class="toggle__visual">
          <div class="toggle__indicator"></div>
        </div>
        <span class="label">
          Critique
        </span>
      </label>

      <app-button @click.native="deleteHandler" variant="text">
        <font-awesome-icon size="sm" icon="trash"></font-awesome-icon>
      </app-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _debounce from 'lodash/debounce';

export default {
  name: 'submission-grid-item',
  props: ['submission'],
  methods: {
    ...mapActions('mySubmissions', ['markSubmission']),
    deleteHandler() {
      this.$emit('delete', this.submission.id);
    },
    toggleCritiqueHandler: _debounce(function() {
      this.markSubmission({
        studyId: this.$route.params.id,
        submissionId: this.submission.id,
      });
    }, 1000),
  },
  computed: {
    ...mapGetters('study', ['deadlinePassed']),
  },
};
</script>

<style lang="scss" scoped>
.submission-grid-item {
  position: relative;
  display: flex;

  &__thumbnail {
    max-width: 100%;
  }

  &__menu {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0.5rem;
    left: 1rem;
    right: 1rem;
    padding: 0 1rem;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(4px);
  }
}

.toggle {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  input {
    opacity: 0;
    user-select: none;
    pointer-events: none;
    position: absolute;
  }

  &__visual {
    background: color('text');
    width: 2rem;
    height: 1rem;
    border: 2px solid color('text');
    box-sizing: content-box;
    margin-right: 0.5rem;
    border-radius: 2rem;
  }
  &__indicator {
    position: absolute;
    left: 2px;
    width: 1rem;
    border-radius: 1rem;
    height: 1rem;
    background: color('background');
    opacity: 0.5;
    transition: all 128ms ease-in-out;
  }

  input[type='checkbox']:checked {
    + .toggle__visual {
      background: color('denotive', 'success');
      border-color: color('denotive', 'success');

      .toggle__indicator {
        background: color('background', 'light');
        transform: translateX(1rem);
        opacity: 1;
      }
    }
  }

  input[type='checkbox']:disabled {
    + .toggle__visual {
      opacity: 0.25;
      cursor: default;
    }
  }
}
</style>
